<template>
  <main>
    <section class="error" v-if="error">
      {{ error }}
    </section>

    <h4 class="sb-row center">
      Impact Report
    </h4>

    <section class="content">
      <sb-dropdown
        class="primary"
        :items="eventTypes"
        :selected.sync="eventType">
        <template #label="{ selected }">
          {{ selected ? selected.label : 'nothing selected' }}
        </template>
        <template #item="{ item }">
          {{ item.label }}
        </template>
      </sb-dropdown>

      <sb-date-range
        v-if="selectedInputType === 'date_range'"
        :start.sync="eventRangeMin"
        :end.sync="eventRangeMax"
        placeholder="choose date" />

      <sb-dropdown
        v-if="selectedInputType === 'select'"
        class="primary"
        :class="{ empty:!eventValue }"
        :items="eventOptions"
        :selected.sync="eventValue">
          <template #label="{ selected }">
            {{ selected ? selected.label : 'nothing selected' }}
          </template>
          <template #item="{ item }">
            {{ item.label }}
          </template>
      </sb-dropdown>

      <div v-if="selectedInputType === 'integer_range'" class="report-row">
        <input type="integer" name="event_range_min" class="sb" v-model="eventRangeMin"/>
        <div class="split">to</div>
        <input type="integer" name="event_range_max" class="sb" v-model="eventRangeMax" />
      </div>

      <div v-if="selectedInputType === 'time_range'" class="report-row">
        <sb-date :value.sync="eventRangeMin" :include="['time']" format="hh:mm aa" placeholder="start time" style="margin-right: 5px"></sb-date>
        <div class="split">to</div>
        <sb-date :value.sync="eventRangeMax" :include="['time']" format="hh:mm aa" placeholder="end time" style="margin-left: 5px"></sb-date>
      </div>

      <div v-if="selectedInputType === 'text' || selectedInputType === 'integer'">
        <input type="text" class="sb" name="event_value" v-model="eventValue"/>
      </div>
    </section>

    <section class="action-bar sb-row start">
      <button class="button" type="submit" @click="initiateReportJob" :disabled="this.waitingForReport">Run Report</button>
    </section>

    <section class="loading-container sb-row center" v-if="this.waitingForReport" >
      <sb-loading-icon />
    </section>

    <section class="report-container" v-if="this.fetchedReport">
      <h5>Results</h5>
      <div>
        <sb-2d-table
          class="impact-report"
          :columns="columns"
          :rows="rows"
          :cells="cells"
        >
          <template #cell="{ row, column }">
            <span :class="cells[row.key][column.key].secondary ? 'cell with-secondary' : 'cell'"">
              <div>{{cells[row.key][column.key].primary}}</div>
              <div>{{cells[row.key][column.key].secondary}}</div>
            </span>
          </template>
        </sb-2d-table>
      </div>
    </section>
  </main>
</template>

<script>
import {ReportAPI} from "../../services/api/Reports";
import {axios} from "../../../packs/axios";

export default {
  name: 'ImpactReport',

  data() {
    return {
      columns: [],
      rows: [],
      cells: {},
      eventType: '',
      eventValue: '',
      eventRangeMin: null,
      eventRangeMax: null,
      reportId: null,
      eventTypes: [],
      eventOptions: [],
      waitingForReport: false,
      fetchedReport: false,
      error: null
    }
  },

  watch: {
    eventType(newEventType) {
      this.reset();
      if(this.selectedInputType === 'select') {
        axios.get(newEventType.data_url)
          .then((resp) => this.eventOptions = resp.data)
          .catch(this.showError);
      }

      if(this.selectedInputType === "time_range") {
        this.eventRangeMin = new Date();
        this.eventRangeMin.setHours(0,0,0,0);

        this.eventRangeMax = new Date();
        this.eventRangeMax.setHours(23,59,59,999);
      }
    }
  },

  computed: {
    selectedInputType() {
      return this.eventType?.input_type
    }
  },

  methods: {
    reset() {
      this.error = null;
      this.eventRangeMin = null;
      this.eventRangeMax = null;
      this.eventValue = '';
      this.reportId = null;
      this.eventOptions = [];
      this.waitingForReport = false;
    },

    initiateReportJob() {
      this.waitingForReport = true;
      this.fetchedReport = false;
      return ReportAPI.postImpactReportJob({
        report: {
          type: 'Reports::ImpactReport',
          input_data: {
            event_type: this.eventType.key,
            event_value: (this.selectedInputType === 'select' ? this.eventValue.key : this.eventValue),
            event_range_min: this.eventRangeMin,
            event_range_max: this.eventRangeMax
          }
        }
      }).then((reportId) => {
        this.reportId = reportId;
        this.pollReport();
      }).catch(this.showError);
    },

    pollReport() {
      setTimeout(() => {
        ReportAPI.fetchReport(this.reportId)
          .then((data) => {
            if(data.report.state === 'completed') {
              this.setTableData(data.report.output_data);
              this.waitingForReport = false;
              this.fetchedReport = true;
            } else {
              this.pollReport();
            }
          }).catch(this.showError);
      }, 1000);
    },

    setTableData(data) {
      const rowsAndCells = data.rows.reduce((res, row) => {
        const key = row.label.toLowerCase().replace(' ', '_');
        res.rows.push({
          label: row.label,
          key
        });

        res.cells[key] = row.values;

        return res;
      }, {
        rows: [],
        cells: {}
      });

      this.columns = data.cols;
      this.rows = rowsAndCells.rows;
      this.cells = rowsAndCells.cells;
    },

    showError(e) {
      this.error = e;
    },
  },

  created() {
    ReportAPI.fetchImpactReportEventTypes()
      .then((data) => this.eventTypes = data)
      .catch(this.showError);
  }
}
</script>

<style>
  .sb-loading-icon {
    width: 100% !important;
    max-width: 200px;
    margin-top: 50px;
  }

  .impact-report {
    column-gap: 10px
  }

  .sb-dropdown, .sb-date-range {
    width: 100%;
    margin-bottom: 15px;
  }

  .report-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between
  }

  .report-row .sb, .report-row .sb-input {
    flex-grow: 1;
  }

  .report-row .split {
    margin: 0 20px;
  }

  .action-bar {
    margin: 20px 0
  }

  .sb-2d-table .cell {
    min-width: 150px;
  }

  .sb-2d-table .cell.with-secondary {
    padding: 4px 25px;
  }

  .sb-2d-table .cell.with-secondary>div:nth-child(1) {
    line-height: 18px;
  }

  .sb-2d-table .cell.with-secondary>div:nth-child(2) {
    line-height: 14px;
    font-size: 0.9em;
  }
</style>
